<template>
  <div class="contact_us_layer">
    <div class="background"></div>
    <div class="background"></div>
    <div class="background"></div>
    <div class="background last"></div>
    <div class="page_1 align_center">
      <div class="contents_wrapper">
        <div class="limited_width_box">
          <div class="section_wrapper">
            <div class="section visit_us">
              <div class="title">
                Visit Us
              </div>
              <div class="description">
                <div class="info_box">
                  <div class="label">Office</div>
                  <div class="info">
                    <span class="item">
                      3F SJ B/D, 13 Gil 2
                      Gohyeon-ro, Geoje-si, Korea
                    </span>
                  </div>
                </div>
                <div class="spacer"></div>
                <div class="info_box">
                  <div class="label">Website</div>
                  <div class="info">
                    <span class="item"><a href="https://www.jinsolutions.com" target="blank" class="dark_sky__">www.jinsolutions.com</a></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section contact">
              <div class="title">
                Contact
              </div>
              <div class="description">
                <div class="info_box">
                  <div class="label">Office</div>
                  <div class="info">
                    <span class="item">+82) 55-632-0390</span>
                  </div>
                </div>
                <div class="spacer"></div>
                <div class="info_box">
                  <div class="label">Email</div>
                  <div class="info">
                    <span class="item">jinkee@jingraphics.com</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { ScrollMixin } from '@/mixins/scroll.mixin'

export default {
  name: 'contact_us',
  mixins: [
    ScrollMixin
  ],
  computed: {
    ...mapState(['scale']),
  },
  mounted() {
    this.init()
    this.$emit('mounted', 'contact_us')
  },
  methods: {
    init() {
      this.setScrollAnime([
        { 
          targets: [
            { name: '.contact_us_layer .page_1 .section.visit_us', status: 'opened' },
            { name: '.contact_us_layer .page_1 .section.contact', status: 'opened' },
          ], 
          in: {
            translateX: [100, 0],
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 2500
          },
          out: {
            translateX: -300,
            opacity: 0,
            easing: "easeOutExpo",
            duration: 2500
          }
        },
      ])
    },
    open() {
      let w = window.outerWidth
      let dgs = document.querySelectorAll('.contact_us_layer .background').length
      let dgWidth = 5

      this.$anime.timeline({loop: false})
      .add({
        targets: '.contact_us_layer .background',
        left: (el, i) => [w, i * dgWidth],
        duration: 1000,
        delay: (el, i) => 75 * i
      })
      .add({
        targets: '.contact_us_layer .background.last',
        width: [dgWidth, w - (dgs-1) * dgWidth],
        easing: "easeOutExpo",
        duration: 500,
      })
      .add({
        targets: '.contact_us_layer .background',
        opacity: 0,
        easing: "easeOutExpo",
        duration: 10000
      })
      this.$anime({
        targets: '.contact_us_layer .page_1 .section.visit_us',
        translateX: [40, 0],
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1500,
        delay: 1250
      })
      this.$anime({
        targets: '.contact_us_layer .page_1 .section.contact',
        translateX: [40, 0],
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1500,
        delay: 1250
      })
    },
    close() {
      window.scrollTo(0, 0)
      
      this.$anime({
        translateY: [0, -100],
        targets: '.contact_us_layer',
        opacity: 0,
        easing: "easeOutExpo",
        duration: 500
      })
      setTimeout(() => {
        this.$emit('closed', 'contact_us')
      }, 500)
    },
  }
}
</script>

<style lang="scss" scoped>
.contact_us_layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;

  .background {
    position: fixed;
    top: 0;
    right: -35px;
    bottom: 0;

    width: 5px;
    background: rgba(0, 0, 0, .1);
  }

  .section_wrapper {
    margin: -4rem !important;
    padding-top: 0 !important;

    .section {
      margin: 4rem !important;
          
      .title {
        font-size: 7rem !important;
      }

      .description {
        font-size: 3rem !important;
        margin-top: 3rem !important;

        .spacer {
          height: 3rem;
        }
        .info_box {
          display: flex;

          .label {
            width: 14rem;
          }
          .info {
            display: flex;
            flex-direction: column;
            
            width: 43rem;
            border-left: solid 1px rgba(255, 255, 255, .5);

            .item {
              margin-left: 2rem;

              a:hover {
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
</style>